<template lang="pug">
  // :key attribute is needed to reinit TaskDetail when route changes
  TaskDetail(:key="$route.params.taskId")
</template>

<script>
import TaskDetail from '@/components/task/detail/TaskDetail.vue';
import DefaultLayout from '@/layouts/Default.vue';

export default {
  name: 'TaskDetailPage',
  components: {
    DefaultLayout,
    TaskDetail,
  },
};
</script>
